import { Theme } from '@mui/material/styles'

const muiFormControlLabel = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        margin: 0
      },
      label: {
        color: theme.palette.text.secondary,
        '&.Mui-disabled': {
          color: theme.colors.placeholder,
          cursor: 'not-allowed'
        }
      }
    }
  }
}

export default muiFormControlLabel
